import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getBirthdays } from "../Service/Api";
import LazyLoad from "react-lazyload";
const Birthday = () => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const topperData = await getBirthdays();
      setData(topperData);
    };
    fetchData();
  }, []);

  const emptyArray = [
    {
      name: "Student Name",
      class: "Class",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cake.png",
    },
    {
      name: "Student Name",
      class: "Class",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cake.png",
    },
    {
      name: "Student Name",
      class: "Class",
      attachments:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/cake.png",
    },
  ];
  return (
    <>
      <div className="row">
        <Slider {...settings}>
          {data.length > 0
            ? data.map((item, index) => {
                const date = new Date(item.date);
                const mon = monthNames[date.getMonth()];
                const eventdate = date.getDate();

                return (
                  <div key={index}>
                    <div className="item">
                      <div className="topperdiv birthday">
                        <div className="toppertaj">
                          {item.attachments.length > 0 ? (
                            <LazyLoad>
                              <img
                                src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                                className="img-fluid"
                              />
                            </LazyLoad>
                          ) : (
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSFL/public/images/trophy.png"
                                className="img-fluid"
                              />
                            </LazyLoad>
                          )}
                        </div>

                        <div className="topperdesc">
                          <p className="name">{item.name}</p>
                          <p className="name">{item.class}</p>
                          <p className="per">
                            {eventdate} {mon}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : emptyArray.map((item, index) => {
                // Set a dynamic placeholder date (today's date)
                const placeholderDate = new Date();
                const mon = monthNames[placeholderDate.getMonth()];
                const eventdate = placeholderDate.getDate();

                return (
                  <div key={index}>
                    <div className="item">
                      <div className="topperdiv birthday">
                        <div className="toppertaj">
                          <LazyLoad>
                            <img
                              src={item.attachments}
                              alt="Placeholder"
                              className="img-fluid"
                            />
                          </LazyLoad>
                        </div>

                        <div className="topperdesc">
                          <p className="name">{item.name}</p>
                          <p className="name">{item.class}</p>
                          <p className="per">DD MM</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          {/* <div className="item">
              <div className="topperdiv birthday">
                <div className="toppertaj">
                  <LazyLoad><img src="/Images/birthday1.jpg" alt="Cannosa school" className="img-fluid" /></LazyLoad>
                  <LazyLoad><img src="/Images/birthday-shape.png" className="img-fluid birthD-shape" alt="Cannosa school" /></LazyLoad>
                </div>

                <div className="topperdesc">
                  <p className="name">Sandhya Yadav</p>
                  <p className="name">VII-A</p>
                  <p className="per">31 Jan</p>
                </div>
              </div>
            </div> 
            <div className="item">
              <div className="topperdiv birthday">
                <div className="toppertaj">
                  <LazyLoad><img src="/Images/birthday2.jpg" alt="Cannosa school" className="img-fluid" /></LazyLoad>
                  <LazyLoad><img src="/Images/birthday-shape.png" className="img-fluid birthD-shape" alt="Cannosa school" /></LazyLoad>
                </div>

                <div className="topperdesc">
                  <p className="name">Deepika Saxena</p>
                  <p className="name">X-C</p>
                  <p className="per">31 Jan</p>
                </div>
              </div>
            </div>  */}
        </Slider>
      </div>
    </>
  );
};

export default Birthday;
